import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ExperienceContext, useConfigService, useStore } from '@thd-nucleus/experience-context';
import {
  useDataModel, params, string, shape, arrayOf,
} from '@thd-nucleus/data-sources';
import { PlpRecsRenderPlaceholder } from '../components/dynamic-recs/PlpRecsRenderPlaceholder';
import { PlpRvRenderPlaceholder } from '../components/recently-viewed/PlpRvRenderPlaceholder';
import { BuyItAgain } from '../components/buyItAgain/buyItAgain';

// Component name constants
const COMPONENT_NAMES = {
  BUY_IT_AGAIN: 'BuyItAgain',
  PLP_RV_RENDER_PLACEHOLDER: 'PlpRvRenderPlaceholder',
  PLP_RECS_RENDER_PLACEHOLDER: 'PlpRecsRenderPlaceholder',
};

export const impPLPRecs = () => {
  return {
    id: '',
    component: 'DynamicRecs',
    type: 'product'
  };
};

export const PLPRecsComposable = (props) => {
  const { componentName } = props;
  const isBuyitagainEnabled = useConfigService('fs-prop:isBuyitagainEnabled') || false;
  const ctx = useContext(ExperienceContext);
  const { customContext } = ctx;
  const {
    varnish, variables, isSearch, isBrandPage, isBrowse
  } = customContext || {};
  const store = useStore({ varnish, online: false });
  const keyword = customContext?.variables?.keyword || '';
  const nValue = customContext?.variables?.navParam;

  const defaultOptions = {
    variables: {
      ...variables,
      storeId: store?.storeId || variables.storeId,
    },
    ssr: true,
    skip: !keyword && !nValue,
  };

  const { data, error, loading } = useDataModel('searchModel', defaultOptions);
  const { searchModel = {} } = data || {};
  const { metadata = {} } = searchModel || {};

  const isCategory = metadata?.contentType === 'categorypage';
  const products = data?.searchModel?.products || [];
  const itemIds = products.map(({ itemId }) => itemId);
  const impressionData = impPLPRecs();
  const filterBrowseRecs = useConfigService('fs:browseFilteredRecs') || false;

  if (componentName === COMPONENT_NAMES.BUY_IT_AGAIN && isBuyitagainEnabled) {
    if (loading) {
      return null;
    }

    const parentFailed = error && (!data?.searchModel || data.searchModel === null);

    return (
      <div className="sui-grid sui-w-full sui-ml-2">
        <BuyItAgain
          nValue={nValue}
          schemaName="buyitagain"
          anchorId={`N-${nValue}`}
          loading={loading}
          data={data}
          error={error}
          zipCode={store?.zipCode}
          keyword={keyword}
          skipDataFetch={!parentFailed}
        />
      </div>
    );
  }
  if (componentName === COMPONENT_NAMES.PLP_RV_RENDER_PLACEHOLDER && !loading) {
    return (<PlpRvRenderPlaceholder isCategory={isCategory} isSearch={isSearch} />);
  }
  if (componentName === COMPONENT_NAMES.PLP_RECS_RENDER_PLACEHOLDER && !loading && !isBrandPage) {
    return (
      <>
        <PlpRecsRenderPlaceholder
          requestKey="aGAQFG4j6QtVTSWqujfFYWeIU6BR5Mee"
          isBrowse={isBrowse}
          keyword={keyword}
          itemIds={itemIds}
          impressionData={impressionData}
          {...(filterBrowseRecs && { browseNValue: nValue })} // eslint-disable-line react/jsx-props-no-spreading
        />
      </>
    );
  }

  return null;
};

PLPRecsComposable.displayName = 'PLPRecsComposable';

PLPRecsComposable.defaultProps = {
  componentName: '',
};

PLPRecsComposable.propTypes = {
  componentName: PropTypes.string,
};

// Define the dataModel for the component
PLPRecsComposable.dataModel = {
  searchModel: params({
    navParam: string(),
    keyword: string(),
    storeId: string(),
  }).shape({
    products: arrayOf(shape({
      itemId: string()
    })),
    metadata: shape({
      contentType: string()
    })
  })
};